import { __makeTemplateObject, __spreadArray, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { IconButton, Sidebar, CloseIcon } from '@elseu/sdu-titan';
import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { NavigationButtons } from './NavigationButtons.js';
import { NavigationLogo } from './NavigationLogo.js';

var StyledNavigationMobile = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n    height: 40px;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    gap: ", ";\n    height: 40px;\n    justify-content: space-between;\n  "])), theme.spacing[4]);
});
var StyledIconButton = styled(IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
/**
 * Flattens the columns in the given menu data, transforming nested children
 * into a one level deep structure, while also adding a 'section' property to
 * each child, containing the title of the parent column.
 *
 * @param {MenuItem[]} data - The menu data containing the items and their children.
 * @returns {SidebarItem[]} The flattened menu data with updated children structure.
 */
var flattenColumns = function (data) {
  return data.map(function (item) {
    var _a;
    return __assign(__assign({}, item), {
      children: (_a = item.children) === null || _a === void 0 ? void 0 : _a.flatMap(function (column) {
        return column.children.map(function (child) {
          return __assign(__assign({}, child), {
            section: column.title
          });
        });
      })
    });
  });
};
/**
 * The NavigationMobile component
 */
var NavigationMobile = function (_a) {
  var isSearchActive = _a.isSearchActive,
    logo = _a.logo,
    main = _a.main,
    top = _a.top,
    setIsSearchActive = _a.setIsSearchActive,
    search = _a.search;
  /**
   * The sidebar items to display.
   */
  var sidebarItems = useMemo(function () {
    if (main && top) {
      return __spreadArray(__spreadArray([], flattenColumns(main), true), top, true);
    }
  }, [main, top]);
  return jsx(StyledNavigationMobile, {
    children: !isSearchActive ? jsxs(Fragment, {
      children: [jsx(Sidebar, {
        brandName: "",
        sidebarItems: sidebarItems
      }), jsx(NavigationLogo, {
        logo: logo
      }), jsx(NavigationButtons, {
        setIsSearchActive: setIsSearchActive
      })]
    }) : jsxs(Fragment, {
      children: [search, jsx(StyledIconButton, {
        label: "Zoeken sluiten",
        icon: jsx(CloseIcon, {
          fontSize: 24
        }),
        onClick: function () {
          return setIsSearchActive(false);
        }
      })]
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { NavigationMobile };
//# sourceMappingURL=NavigationMobile.js.map
